// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tgr-row {
    display: grid;
    margin: 0;
    width: 100%;
    column-gap: var(--grid-xs-gutter); 
    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media screen and (min-width: 768px) {
    .tgr-row {
        column-gap: var(--grid-md-gutter);
        grid-template-columns: repeat(12, minmax(0, 1fr))
    }
}

@media screen and (min-width: 1024px) {
    .tgr-row {
        column-gap: var(--grid-lg-gutter);
        grid-template-columns: repeat(12, minmax(0, 1fr))
    }
}

@media screen and (min-width: 1440px) {
    .tgr-row {
        column-gap: var(--grid-xl-gutter);
        grid-template-columns: repeat(12, minmax(0, 1fr))
    }
}`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-web-core/dist/grid/row.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,iCAAiC;IACjC;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC;IACJ;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC;IACJ;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC;IACJ;AACJ","sourcesContent":[".tgr-row {\n    display: grid;\n    margin: 0;\n    width: 100%;\n    column-gap: var(--grid-xs-gutter); \n    grid-template-columns: repeat(1, minmax(0, 1fr))\n}\n\n@media screen and (min-width: 768px) {\n    .tgr-row {\n        column-gap: var(--grid-md-gutter);\n        grid-template-columns: repeat(12, minmax(0, 1fr))\n    }\n}\n\n@media screen and (min-width: 1024px) {\n    .tgr-row {\n        column-gap: var(--grid-lg-gutter);\n        grid-template-columns: repeat(12, minmax(0, 1fr))\n    }\n}\n\n@media screen and (min-width: 1440px) {\n    .tgr-row {\n        column-gap: var(--grid-xl-gutter);\n        grid-template-columns: repeat(12, minmax(0, 1fr))\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
